// import { Suspense } from 'react';

// // project import
// import Loader from './Loader';

// // ==============================|| LOADABLE - LAZY LOADING ||============================== //

// const Loadable = (Component) => (props) =>
//   (
//     <Suspense fallback={<Loader />}>
//       <Component {...props} />
//     </Suspense>
//   );

// export default Loadable;

import { Suspense } from 'react';

// project import
import Loader from './Loader';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const Loadable = (Component) => {
  const WrappedComponent = (props) => (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );

  // Set display name for debugging
  WrappedComponent.displayName = `Loadable(${Component.displayName || Component.name || "Component"})`;

  return WrappedComponent;
};

export default Loadable;
